import { useMutation } from "@apollo/client";
import { Button, ModalFooter, useMediaQuery, useToast } from "@chakra-ui/react";
import { capitalize, omit, set, startCase } from "lodash";

import ModalWrapper from "../../ModalWrapper";
import CreateCommodityForm from "./CreateCommodityForm";
import { CREATE_COMMODITIES } from "./mutations";

type Props = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  refetch?: any;
};

const CreateCommodity = (props: Props) => {
  const { isOpen, onClose, refetch } = props;
  const toast = useToast();
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [createCommodity, { loading }] = useMutation(CREATE_COMMODITIES);

  const onSubmit = (values: any) => {
    const { retail, wholeSale } = values;

    if (retail) {
      set(values, "retail", Number(retail));
    }

    if (wholeSale) {
      set(values, "wholeSale", Number(wholeSale));
    }
    
    return createCommodity({
      variables: {
        inputs: [
          {
            ...values,
            useCurrentLocation: true,
          },
        ],
      },
      // refetchQueries: [
      //   {
      //     query: GET_COMMODITIES,
      //     variables: {
      //       args: {
      //         pagination: {
      //           page: 1,
      //           size: 20,
      //         },
      //       },
      //     },
      //   },
      // ],
    })
      .then((data: any) => {
        if (data) {
          onClose();
          refetch && refetch();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: `${capitalize(data?.data.itemCreate[0].name)} was created`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
            });
          }
        }
      })
      .catch((error) => {
        if (!toast.isActive("active-toast")) {
          toast({
            id: "active-toast",
            title: error.message,
            description: "Please, try again.",
            status: "error",
            duration: 2000,
            isClosable: true,
            variant: "solid",
          });
        }
      });
  };
  const formName = "createCommodityForm";
  return (
    <ModalWrapper onClose={onClose} isOpen={isOpen} title="Commodity | Create">
      <CreateCommodityForm onSubmit={onSubmit} formName={formName} />

      <ModalFooter>
        <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={isLargerThan900 ? "50" : "full"}
          form={formName}
          colorScheme="whatsapp"
          type="submit"
          isLoading={loading}
          isDisabled={loading}
        >
          Create
        </Button>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default CreateCommodity;
